import React from "react";
import { styles } from "../styles/style";
const SubadminAccess = () => {
  return (

    <div className="w-[40vw] ml-[30vw]">
      <h1>Trichy</h1>

      <form>

        <p>Plan 1 - Basic</p>
        <label className={`${styles.label}`}>Total units</label>
        <div className="flex gap-4">
          <input type="text" className={`${styles.input} `} />

          <button className={`${styles.button} !w-[100px]`}>update</button>
        </div>

        <p>Plan 1 - Basic</p>
        <label className={`${styles.label}`}>Total units</label>
        <div className="flex gap-4">
          <input type="text" className={`${styles.input} `} />

          <button className={`${styles.button} !w-[100px]`}>update</button>
        </div>
        <p>Plan 1 - Basic</p>
        <label className={`${styles.label}`}>Total units</label>
        <div className="flex gap-4">
          <input type="text" className={`${styles.input} `} />

          <button className={`${styles.button} !w-[100px]`}>update</button>
        </div>
      </form>
    </div>
  );
};

export default SubadminAccess;
